/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PayrollViewerControllerGetViewer200ResponseDataLinesInnerConceptsInner } from './payrollViewerControllerGetViewer200ResponseDataLinesInnerConceptsInner';


export interface PayrollViewerControllerGetViewer200ResponseDataLinesInner { 
    key?: string;
    label?: string;
    type?: PayrollViewerControllerGetViewer200ResponseDataLinesInner.TypeEnum;
    category?: PayrollViewerControllerGetViewer200ResponseDataLinesInner.CategoryEnum;
    level?: number;
    order?: number;
    monthlyAmount?: number;
    concepts?: Array<PayrollViewerControllerGetViewer200ResponseDataLinesInnerConceptsInner>;
}
export namespace PayrollViewerControllerGetViewer200ResponseDataLinesInner {
    export type TypeEnum = 'concept' | 'subtotal' | 'total';
    export const TypeEnum = {
        Concept: 'concept' as TypeEnum,
        Subtotal: 'subtotal' as TypeEnum,
        Total: 'total' as TypeEnum
    };
    export type CategoryEnum = 'investment' | 'tax' | 'pay';
    export const CategoryEnum = {
        Investment: 'investment' as CategoryEnum,
        Tax: 'tax' as CategoryEnum,
        Pay: 'pay' as CategoryEnum
    };
}


